import { INITIAL_HERO_INVENTORY } from '../Classes/utils/constants';
import { EQUIPMENT_LIST } from '../Classes/equipment';

// Starter inventory for warrior: 3 potions + 1 chain mail (to equip) + 1 strength ring.
const WARRIOR_STARTER_INVENTORY = {
    slot1: { ...INITIAL_HERO_INVENTORY.slot1 },
    slot2: { ...INITIAL_HERO_INVENTORY.slot2 },
    slot3: { ...INITIAL_HERO_INVENTORY.slot3 },
    slot4: { item: { ...EQUIPMENT_LIST.chainMail }, quantity: 1 },
    slot5: { item: { ...EQUIPMENT_LIST.strengthRing }, quantity: 1 },
};

// Starter inventory for mage: 3 potions + an apprentice staff + swift boots.
const MAGE_STARTER_INVENTORY = {
    slot1: { ...INITIAL_HERO_INVENTORY.slot1 },
    slot2: { ...INITIAL_HERO_INVENTORY.slot2 },
    slot3: { ...INITIAL_HERO_INVENTORY.slot3 },
    slot4: { item: { ...EQUIPMENT_LIST.apprenticeStaff }, quantity: 1 },
    slot5: { item: { ...EQUIPMENT_LIST.swiftBoots }, quantity: 1 },
};

// Test account with a warrior hero
const heroAccount = {
    id: 1,
    nickname: 'warrior_user',
    password: 'warrior123',
    gameData: {
        hero: {
            classType: "WARRIOR",
            gender: "male",
            gold: 200,
            inventory: WARRIOR_STARTER_INVENTORY,
            level: 5,
            name: "WarriorHero",
            position: {
                mapId: "map1",
                x: 5,
                y: 4,
            },
            skinFemale: "assets/images/heros/warrior_f.png",
            skinMale: "assets/images/heros/warrior_m.png",
            stats: {
                dexterity: 10,
                health: 150,
                intelligence: 5,
                mana: 50,
                maxHealth: 150,
                maxMana: 50,
                strength: 15,
                vitality: 12
            },
            xp: 1000,
            equipment: {
                weapon: { ...EQUIPMENT_LIST.ironSword },
                helm: { ...EQUIPMENT_LIST.leatherCap },
            },
            skills: [],
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
        },
    }
};

// Test account with a mage hero
const mageHeroAccount = {
    id: 2,
    nickname: 'mage_user',
    password: 'mage123',
    gameData: {
        hero: {
            classType: "MAGE",
            gender: "female",
            gold: 150,
            inventory: MAGE_STARTER_INVENTORY,
            level: 3,
            name: "MageHeroine",
            position: {
                mapId: "map1",
                x: 8,
                y: 3,
            },
            skinFemale: "assets/images/heros/mage_f.png",
            skinMale: "assets/images/heros/mage_m.png",
            stats: {
                dexterity: 12,
                health: 90,
                intelligence: 18,
                mana: 100,
                maxHealth: 90,
                maxMana: 100,
                strength: 6,
                vitality: 8
            },
            xp: 450
        },
    }
};

const noHeroAccount = {
    id: 3,
    nickname: 'new_user',
    password: 'new123',
    gameData: null
};

export const USERS = [heroAccount, noHeroAccount, mageHeroAccount];